var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2258_26479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59534 9.20142C1.59552 9.2015 1.59552 9.20159 1.59578 9.20177L4.9663 12.5725L4.96648 12.5723V12.5724L6.35023 11.1888L6.88049 11.7191L7.73379 12.5724L9.62325 10.6831C9.62343 10.6829 9.6237 10.6827 9.62388 10.6825L15.8232 4.48321C16.0587 4.24757 16.0587 3.86554 15.8232 3.6299C15.5875 3.3942 15.2054 3.3942 14.9697 3.6299L8.77039 9.82922C8.77022 9.82931 8.77022 9.82957 8.76995 9.82975L7.73379 10.8658L7.20352 10.3356L13.0559 4.48321C13.2914 4.24758 13.2914 3.86555 13.0559 3.62991C12.8202 3.39421 12.4381 3.39421 12.2024 3.62991L6.00307 9.82923C6.00289 9.82932 6.00289 9.82958 6.00262 9.82976L4.96619 10.8659L2.02173 7.92146L1.02959 6.92924C0.793889 6.69353 0.411649 6.69353 0.176289 6.92924C-0.059414 7.16487 -0.059414 7.54691 0.176289 7.78254L1.59534 9.20142Z",
    fill: "#4D55E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9016 8.74184C3.90178 8.74202 3.90205 8.7422 3.90223 8.74237L4.78936 9.6295L5.64266 8.7762L4.75553 7.88907C4.75535 7.88898 4.75535 7.88871 4.75508 7.88854L3.79723 6.93068C3.56153 6.69498 3.17947 6.69498 2.94375 6.93068C2.7082 7.16632 2.7082 7.54835 2.94375 7.78399L3.9016 8.74184Z",
    fill: "#4D55E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2258_26479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double-check.0757972ef19b4b363b91c5ac634582ad.svg";
export { ForwardRef as ReactComponent };